import styles from './CartItemImage.module.scss';

interface CartItemImageProps {
    productId: string;
}

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export default function CartItemImage({ productId }: CartItemImageProps) {
    if (!productId || productId === EMPTY_GUID) {
        return <div className={styles.image_container} />;
    }
    return (
        <div className={styles.image_container}>
            <img className={styles.producer_image} src={`${process.env.REACT_APP_BASE_URL}Images/GetDimensionedProductImage/${productId}/70/70`} alt="product" />
        </div>
    );
}
